import React, { useEffect, useRef, useState, } from 'react'
import uplaodtax from 'src/assets/images/upload-tax.svg';
import downloadpdf from 'src/assets/images/download-pdf.svg';
import Constants from "../../helper/Constants";
import useReduxState from "../../hooks/useReduxState";
import { useCheckout } from "../../hooks/checkout";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import { useOrderStore } from "../../hooks/order";
import { Beacon } from 'src/component/Global/Beacon';

const TaxExempt = () => {
    const [__check] = useAxiosIndicatorCheck();
    const inputRef = useRef(null);

    const { taxExempt: { EXEMPT, NONE, OVERWRITE }, TaxExemptFormURL } = Constants

    const [{ }, { }, { upload_tax_exempt }] = useCheckout();
    const [{ validate_order_from_server }] = useOrderStore();

    const [showMessage, setShowMessage] = useState(false)

    const [taxExemptDetails, setTaxExemptDetails] = useReduxState({ taxExemptFile: '', taxExempt: NONE }, "setTaxExemptDetails");

    const handleChange = async (e) => {
        e.preventDefault();
        if (e.target.files) {
            const inputObj = e.target.files[0];
            const formData = new FormData();
            formData.append('formFile', inputObj);
            const res = await upload_tax_exempt(formData);
            if (res.isSuccessFull) {
                setTaxExemptDetails({ ...taxExemptDetails, taxExemptFile: res.data?.fileUrl });
                setShowMessage(true)
            }
            e.target.value = null;
        }
    };

    useEffect(() => {
        setTaxExemptDetails({ ...taxExemptDetails, taxExempt: taxExemptDetails?.taxExempt === OVERWRITE ? OVERWRITE : (validate_order_from_server?.taxExempt ? EXEMPT : NONE) })
    }, [validate_order_from_server]);

    return (<>
        <div className='col-12 tax-exempt step-complete-hide'>
            <hr className='mt-0'></hr>
            <h3 className="mt-0 mb-2">TAX EXEMPT:</h3>
            {!validate_order_from_server?.taxExempt && <>
                <p>Your account is not currently setup to receive tax exemption. Please submit a tax certificate
                    to begin process.</p>
                <div className='d-flex align-items-center mb-2 upload-tax-exempt position-relative'>
                    <Beacon position={"right"} content={() => "If you have your State Tax Certificate, please upload here"}
                        opener={() => (
                            <div className="becon-dot"></div>
                        )} />
                    <img src={uplaodtax} alt='Upload Tax Exempt Certificate' className='me-2' />
                    <input type="file" ref={inputRef} id="input-file-upload" style={{ display: 'none' }}
                        onChange={handleChange} /> <a
                            href={void (0)} className={'text-blue2'} onClick={() => inputRef.current.click()}><u>Upload Tax
                                Exempt
                                Certificate</u>
                    </a>
                    {__check('TAX_EXEMPT_FILE_UPLOAD').status && __check('TAX_EXEMPT_FILE_UPLOAD').render}
                </div>
                {showMessage && (
                    <div className="alert alert-success alert-taxexempt">
                        <span><strong>Upload Successful!</strong>  Your file has been uploaded successfully.  </span>
                        <i className="fa fa-check-circle-o ms-auto" aria-hidden="true"></i>
                    </div>
                )}
                <p className='font-10'>Orders checked as non-taxable will not ship until a valid tax certificate
                    is received. <strong> Your order may be taxed while we set up your account. You will receive
                        a tax credit, if applicable.</strong> Download the Certificate of Exemption Form below.
                    You can request a specific state form at <a href='#'> Sales-Tax@Avnet.com.</a> For general
                    questions please contact us at 1 (800) 408-8353. Pricing does not include applicable
                    federal, state, or local sales, use of the taxes or import duties imposed on Avnet or its
                    suppliers. (If Hawaii excise taxes are applicable, rates are as follow .05% for Wholesale
                    transactions and 4% Retail transactions.)</p>
                <div className='d-flex align-items-center mb-2 position-relative'>
                    <Beacon position={"right"} content={() => "If you cannot provide a state issued tax document please download Multi-jurisdiction Document here."}
                        opener={() => (
                            <div className="becon-dot"></div>
                        )} />
                    <img src={downloadpdf} alt='Download Certificate of Exemption Form' className='me-1' />
                    <a href={TaxExemptFormURL} target={'_blank'} className='' rel="noreferrer">Download
                        Certificate of
                        Exemption Form</a>
                </div>
            </>}
            {validate_order_from_server?.taxExempt &&
                <>
                    <p>Your account has tax exempt status</p>
                    <div className="form-check mb-1 mt-3"><input type="checkbox" className={'form-check-input mt-1'}
                        checked={taxExemptDetails?.taxExempt === OVERWRITE} id="overrideTax"
                        name={'overrideTax'} onChange={(event) => {
                            setTaxExemptDetails({ ...taxExemptDetails, taxExempt: event.target.checked ? OVERWRITE : EXEMPT });
                        }} />
                        <label className="cursor-pointer" htmlFor="overrideTax">Override my tax exempt status for
                            this order</label>
                    </div>
                </>
            }
        </div>
    </>);
}

export default TaxExempt;